import { log } from 'console';
import { jwtDecode } from 'jwt-decode';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

interface TokenPayload {
  exp: number;
}

const ProtectedRoute: React.FC = () => {
  const token = localStorage.getItem('AuthToken');

  if (!token) {
    return <Navigate to="/login" />;
  }

  const decoded: TokenPayload = jwtDecode(token);

  // Get the current time (in seconds)
  const currentTime = Date.now() / 1000; // Convert to seconds

  
  
  if(decoded.exp < currentTime) {
    localStorage.removeItem('AuthToken');
    return <Navigate to="/login" />;
  }
  
  return <Outlet />;
};

export default ProtectedRoute;
